import { MarketResearchShareData } from "core/src/features";
import { MarketResearchShareResponse } from "./marketResearchShareResponse";

export const convertMarketResearchShareResponse = (
    res: MarketResearchShareResponse
) => {
    if (!res) return null;

    const result: MarketResearchShareData = {
        emailUrl: res.emailUrl,
        shortenedUrl: res.shortenedUrl,
    };

    return result;
};
